// extracted by mini-css-extract-plugin
export default {"edit":"InfoNote_edit__zPbfz","noteText":"InfoNote_noteText__T1d3-","commonIcon":"InfoNote_commonIcon__CImAW"};